import Vue from 'vue';
import Vuex from 'vuex';
import global from './modules/global';
import customInfo from './modules/customInfo';
import region from './modules/region';
import userInfo from './modules/userInfo';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    global,
    customInfo,
    region,
    userInfo
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js